/**
 * Checkout Response Route - React Router v7
 *
 * Routes (all share this component via child paths under /checkout):
 *   /checkout/success, /checkout/error, /checkout/pending, /checkout/refund-error,
 *   /checkout/activation-error, /checkout/request-error, /checkout/unknown-error.
 *
 * The single CheckoutResponsePage renders different content based on the URL
 * (its component derives the result from the pathname internally).
 */
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, no-console */
import type {LoaderFunctionArgs} from 'react-router-dom'
import {useLoaderData} from 'react-router-dom'

import CheckoutResponsePage from './response.js'

import './styles/index.scss'

export async function loader({context, request}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname.endsWith('/') ? url.pathname : `${url.pathname}/`
  const query: Record<string, string> = {}
  url.searchParams.forEach((value, key) => {
    query[key] = value
  })

  const routeInfo = {location: {pathname, search: url.search, query}}

  try {
    // CheckoutResponsePage.getInitialProps is defined as a static method on the component
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const initialProps = await (CheckoutResponsePage as any).getInitialProps({routeInfo, context})
    return {...initialProps, __RR7__: true}
  } catch (error: unknown) {
    console.error('[RR7] CheckoutResponse loader error:', error)
    throw error
  }
}

export function Component() {
  const data = useLoaderData()
  return <CheckoutResponsePage {...data} />
}

Component.displayName = 'CheckoutResponseRoute'
